import React, { useEffect, useState } from 'react';
import { Icon, Button } from '@abb/abb-common-ux-react';
import * as CONSTANTS from "../../utilities/Constants";
import { useTranslation } from 'react-i18next';
import { FileUploader } from "react-drag-drop-files";
import uploadLicenseFileStore from '../../flux/stores/license/uploadLicenseFileStore';
import licenseActions from '../../flux/actions/LicenseActions';
import History from "../../utilities/History";

interface LicenseStatusProps {
    expirationDate: string;
    handleFileUpload: any;
    isLicenseExists: boolean;
    isFileUploadFailed: boolean;
    handleChange: any;
    file: any;
    licenseDetails: any;
    onTypeError: any;
    isErrorFileType?: boolean;
}
const fileTypes = ["SLA"];
const LicenseStatus: React.FC<LicenseStatusProps> = ({ ...props }) => {
    const { t } = useTranslation();

    return (
        <form>
            <div>
                {props.expirationDate ? 
                    <>{t(CONSTANTS.LICENSE_EXPIRED)} <span className='license-text-bold'>{props.expirationDate}</span></>
                    :
                    t(CONSTANTS.LICENSE_NOT_FOUND)}
                <br /><br />
                {t(CONSTANTS.LICENSE_EXPIRED_TEXT)}
                <br /><br />
                <div>{t(CONSTANTS.LICENCE_SUPPORT_INFO)} <a className="mailto" href="mailto:lw.technicalsupport@se.abb.com">lw.technicalsupport@se.abb.com</a></div>
                <br /><br />
                <div className='license-file'>
                    <FileUploader
                        handleChange={props.handleChange}
                        onTypeError={props.onTypeError}
                        name="file"
                        types={fileTypes}>
                        <div className="license-text">
                            <div><Icon
                                name="abb/upload"
                                sizeClass="small"
                                style={{ cursor: "pointer" }}
                            />
                                <span className="license-upload">{props.file && props.file?.name ? props.file?.name : t("Select or drop a file right here")}</span></div>
                            <span className="file-types">{fileTypes}</span>
                        </div>
                    </FileUploader>
                    <Button type="primary-black"
                        shape="rounded"
                        text={t(CONSTANTS.SLA_UPLOAD_BUTTON)}
                        onClick={() => props.handleFileUpload(props.file)}
                        disabled={props.file ? props.isErrorFileType ? true : false : true}
                         />
                </div>
                {/* <p>{props.file ? `File name: ${props.file.name}` : "No files uploaded yet"}</p> */}
                {props.isErrorFileType && <p className='license-upload-failed'>{t("File type is not supported")}</p>}
                {props.isFileUploadFailed && <p className='license-upload-failed'>{t("File upload failed, Please try again with valid License File")}</p>}
            </div>
        </form>
    );
};

export default LicenseStatus;